/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { TestSessionInstrumentDto } from 'modules/InstrumentsQualityControl/models';
import InstrumentTestConfirmDialog from '../InstrumentTestConfirmDialog';

export default ({
  title = 'Sign Off Visual Inspection',
  initialValues = {},
  test,
  ...props
}: { test?: TestSessionInstrumentDto | null } & Record<string, any>) => (
  <InstrumentTestConfirmDialog
    title={title}
    type="visual-inspection"
    test={test}
    buttonText="Save"
    initialValues={{
      ...initialValues,
      instrumentId: test?.instrument?.id,
      outcome: test?.visualInspection?.visualInspectionOutcome,
      comment: '',
    }}
    {...props}
  />
);
